// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import Hero from "./components/Hero";
import Main from "./components/Main";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import Contact from "./components/Contact";
//import Order from './components/Order';
//import Success from './components/Success';
//import Failed from './components/Failed';
//import Cancel from './components/Cancel';
//import DeliveriesPage from './components/DeliveriesPage';

function App() {
  return (
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <Header />
              <Hero />
              <Main />
              <Footer />
            </div>
          }
        />

        <Route
          path="/menu"
          element={
            <div className="App">
              <Header />           
              <Menu />             
              <Footer />           
            </div>
          }
        />

        <Route 
          path="/contact"
          element={
            <div className='App'>
              <Header />
              <Contact />
              <Footer />
            </div>
          }
        />

        {/* <Route 
          path='/order'
          element={
            <div className="App">
              <Header />
              <Order />
              <Footer />
            </div>
          }
        /> */}

        {/* <Route path="/success" element={<Success />} />
        <Route path="/failed" element={<Failed />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/deliveries" element={<DeliveriesPage />} /> */}

      </Routes>
  );
}

export default App;